import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import PeopleOutline from '@mui/icons-material/PeopleOutline';
import StaffLayout, { PageHeading } from '../components/StaffLayout';
import VisitDirectory from '../components/VisitDirectory';

export default function Visits() {
    return <StaffLayout><PageHeading eyebrow="PATIENT CARE" title="Visits" description="Every consultation, in one clear view." action={<Button component={Link} to="/patients" variant="contained" startIcon={<PeopleOutline />}>Select patient to add visit</Button>} /><VisitDirectory /></StaffLayout>;
}
